import { get, post } from '../Services/http'
import { catchError } from './Error.action'

export const COUNTRIES_RECEIVE = 'COUNTRIES_RECEIVE'
export const SUPPORT_TYPES_RECEIVE = 'COUNTRIES_RECEIVE'
export const SUPPORT_CLAIMS_CATEGORIES_RECEIVE =
    'SUPPORT_CLAIMS_CATEGORIES_RECEIVE'
export const CONTACT_FORM_SENT_RECEIVE = 'CONTACT_FORM_SENT_RECEIVE'
export const RECEIVE_ERROR = 'RECEIVE_ERROR'

export const getCountries = () => (dispatch, getState) => {
    return get('/api/contact/countries')
        .then((response) => response.json())
        .then((data) => dispatch(receiveCountries(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const getSupportTypes = () => (dispatch, getState) => {
    return get('/api/contact/supporttypes')
        .then((response) => response.json())
        .then((data) => dispatch(receiveSupportTypes(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))))
}

export const getClaimCategories = () => (dispatch, getState) => {
    return get('/api/contact/claimcategories')
        .then((response) => response.json())
        .then((data) => dispatch(receiveClaimCategories(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))))
}

export const createTicket = (contact, file) => (dispatch) => {
    let formData = new FormData()

    formData.append('contact', JSON.stringify(contact))

    if (file !== null) {
        formData.append('file', file)
    }

    let options = {
        method: 'POST',
        headers: {
            'litium-request-context': JSON.stringify(
                window.__litium.requestContext
            ),
        },
        credentials: 'include',
    }

    const token = window.localStorage.getItem('requestVerificationToken')
    if (token) {
        options = {
            ...options,
            headers: {
                ...options.headers,
                RequestVerificationToken: token,
            },
        }
    }

    return fetch('/api/contact/createticket', { ...options, body: formData })
        .then((response) => response.json())
        .then((response) => dispatch(contactFormSent(response)))
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))))
}

export const setError = (error) => ({
    type: RECEIVE_ERROR,
    payload: {
        error,
    },
})

export const receiveCountries = (data) => {
    return {
        type: COUNTRIES_RECEIVE,
        payload: {
            countries: data,
        },
    }
}

export const receiveSupportTypes = (data) => {
    return {
        type: SUPPORT_TYPES_RECEIVE,
        payload: {
            supportTypes: data,
        },
    }
}

export const receiveClaimCategories = (data) => {
    return {
        type: SUPPORT_CLAIMS_CATEGORIES_RECEIVE,
        payload: {
            claimCategories: data,
        },
    }
}

export const contactFormSent = (data) => {
    return {
        type: CONTACT_FORM_SENT_RECEIVE,
        payload: {
            contactFormSent: data,
        },
    }
}
